import React from "react";

const JourneyMap = ({ steps, activeIndex }) => {
  const n = steps.length;
  const fillFrac = n > 1 ? activeIndex / (n - 1) : 1;
  const activeStep = steps[activeIndex] || steps[0];

  return (
    <div className="hiw-map">
      <div className="hiw-grid" aria-hidden="true" />

      {/* progress rail */}
      <div className="hiw-rail" aria-hidden="true">
        <div className="hiw-rail-line" />
        <div className="hiw-rail-fill" style={{ height: `${fillFrac * 100}%` }} />
        {steps.map((_, i) => (
          <span
            key={i}
            className={`hiw-rail-dot ${i <= activeIndex ? "is-on" : ""} ${
              i === activeIndex ? "is-active" : ""
            }`}
            style={{ top: n > 1 ? `${(i / (n - 1)) * 100}%` : "50%" }}
          />
        ))}
      </div>

      {/* active illustration fills the panel (crossfades on step change) */}
      <div className="hiw-stage" aria-hidden="true">
        {steps.map((step, i) => (
          <img
            key={i}
            src={step.image}
            alt=""
            className={`hiw-stage-img ${i === activeIndex ? "is-active" : ""}`}
          />
        ))}
      </div>

      {/* current-step label */}
      <div className="hiw-map-label">
        <span className="hiw-map-label-dot" />
        {activeStep.title}
      </div>
    </div>
  );
};

export default JourneyMap;
